import { DEFAULT_LANG, type Lang } from '@dc1/shared';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '../locales/en.json';
import vi from '../locales/vi.json';
import { readPref, writePref } from './ui-prefs';

export const resources = { vi: { translation: vi }, en: { translation: en } } as const;

export function initI18n(lang: Lang = readPref('ui.lang') ?? DEFAULT_LANG) {
  void i18n.use(initReactI18next).init({
    resources,
    lng: lang,
    fallbackLng: DEFAULT_LANG,
    interpolation: { escapeValue: false }, // React escapes already
    returnObjects: true,
  });
  document.documentElement.lang = lang;
  return i18n;
}

export function setLanguage(lang: Lang): void {
  void i18n.changeLanguage(lang);
  document.documentElement.lang = lang;
  writePref('ui.lang', lang);
}

export function currentLang(): Lang {
  return i18n.language === 'en' ? 'en' : 'vi';
}
